export default __webpack_public_path__ + "static/media/indigo.435055bc.jpg";